module.exports = __webpack_public_path__ + "static/media/profile.17c77e60.png";